import React from "react";

export default function MyPorperties() {
  return <div>MyPorperties</div>;
}
